module.exports = __webpack_public_path__ + "img/hope-land.dc67ce41.jpg";